import { useEffect } from 'react';

export const useModalOpen = (keepPosition = true) => {
    useEffect(() => {
        if (document.body.style.position !== 'fixed') {
            const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            if (keepPosition) {
                document.body.style.top = `${-scrollTop}px`;
            }

            return () => {
                document.body.style.position = 'unset';
                document.body.style.width = 'unset';
                if (keepPosition) {
                    document.body.scrollTop = document.documentElement.scrollTop = scrollTop;
                }
            };
        }
    }, []);
};
